export const animateCardsContent = (
  tl: gsap.core.Timeline,
  cardsContentLight: HTMLElement[],
  cardsContentDark: HTMLElement[],
  nextTheme: 'light' | 'dark',
) => {
  tl.to(
    cardsContentLight,
    {
      opacity: nextTheme === 'light' ? 1 : 0,
      duration: 0.6,
      ease: 'power3.out',
    },
    0,
  ).to(
    cardsContentDark,
    {
      opacity: nextTheme === 'dark' ? 1 : 0,
      duration: 0.6,
      ease: 'power3.out',
    },
    0,
  );
};
